import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import ApiConfig from '../api/ApiConfig';
import { simpleGetCall } from '../api/ApiServices';

const PrivacyPolicyDescp = () => {

    const [privacyTxt, setPrivacyTxt] = useState([]);

    useEffect(() => {
        fetchPrivacy();
    }, [])

    const fetchPrivacy = () => {
        simpleGetCall(ApiConfig.GET_PRIVACY_POLICY)
            .then((data) => {
                setPrivacyTxt(data.commonText);
                // setLoading(false);
                console.log("Privacy Data", data.commonText);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div className='logout_aboutUs'>
            <div className='innerCardAbt'>
                <h2 className='headingTxt'>Privacy Policy Description</h2>
                <label className='InsideTxt'>{privacyTxt}</label>
            </div>
        </div>
    )
}

export default PrivacyPolicyDescp;
